import images from 'shared/paths/images';
import routes from 'shared/paths/routes';

export default {
  images,
  routes,
};
